// https://stackoverflow.com/questions/33076177/getting-name-initials-using-js

export function getNameInitials(name: string) {
  const nameArr = name.trim().split(/\s+/)
  const initialsArr = nameArr
    .map((n, i) => (i === 0 || i === nameArr.length - 1) && n[0])
    .filter((n) => n) as string[]
  return initialsArr.map((n) => n.toUpperCase()).join('')
}
